export const SITE_URL = 'https://bar-ranca-ptuj.si';